import * as React from 'react';
import { IconPhone16 } from '@cian/ui-kit';
import { useSelector } from 'react-redux';

import { trackPhoneExpand, trackMortgageClick, trackAvailableJkClick } from './tracking';
import { PromoDescriptionModal } from '../../components/PromoDescriptionModal';
import { getGaLabel, getNewbuildingId } from '../../selectors/newbuilding';
import { IAvailableJk, IPromo } from '../../types/newbuilding/promos';
import { trackOpenContacts } from '../Call/tracking';
import { CallButton } from '../CallButton';

interface IPromoDescriptionModalContainerProps {
  onClose(): void;
  open: boolean;
  promo: IPromo;
}

const contactsButtonProps = {
  beforeIcon: <IconPhone16 color="white_100" />,
};

export function PromoDescriptionModalContainer({ open, onClose, promo }: IPromoDescriptionModalContainerProps) {
  const newbuildingId = useSelector(getNewbuildingId);
  const gaLabel = useSelector(getGaLabel);

  const handleJkClick = React.useCallback(
    (jk: IAvailableJk, index: number) => {
      trackAvailableJkClick({
        newbuildingId: jk.id,
        position: index + 1,
        promoType: promo.promoType,
        promoId: promo.promoId,
        promoCianMortgage: promo.uniquePromoId,
      });
    },
    [promo],
  );

  const handleMortgageClick = React.useCallback(() => {
    trackMortgageClick({
      newbuildingId,
      promoType: promo.promoType,
      promoId: promo.promoId,
      promoCianMortgage: promo.uniquePromoId,
    });
  }, [promo, newbuildingId]);

  const handleShowPhoneClick = React.useCallback(() => {
    trackPhoneExpand({
      newbuildingId,
      gaLabel,
      promoType: promo.promoType,
      promoId: promo.promoId,
      promoCianMortgage: promo.uniquePromoId,
    });
  }, [promo, gaLabel, newbuildingId]);

  const handleOpenPhonesClick = React.useCallback(() => {
    trackOpenContacts(gaLabel);
  }, [gaLabel]);

  return (
    <PromoDescriptionModal
      promo={promo}
      open={open}
      onClose={onClose}
      onJkClick={handleJkClick}
      onMortgageClick={handleMortgageClick}
      contactsButton={
        promo.isFromBank ? (
          <CallButton
            placeType={`Promo_${promo.uniquePromoId}`}
            openContactsStyles={contactsButtonProps}
            showPhoneStyles={contactsButtonProps}
            onShowPhoneClick={handleShowPhoneClick}
            onOpenContactsClick={handleOpenPhonesClick}
          />
        ) : null
      }
    />
  );
}
